import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <main className="pt-32 pb-20 px-4">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto bg-white p-8 md:p-16 rounded-[40px] shadow-2xl border border-gray-100"
        >
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-10 border-b border-gray-100 pb-8">
            Kebijakan Privasi
          </h1>
          
          <div className="prose prose-indigo max-w-none text-gray-600 space-y-10 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-5 flex items-center gap-3">
                <span className="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center text-sm">1</span>
                Pendahuluan
              </h2>
              <p>
                Selamat datang di <strong>candradimuka.id</strong>. Kami sangat menghargai privasi Anda dan berkomitmen untuk melindungi data pribadi Anda. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan menjaga informasi Anda saat Anda menggunakan situs web kami, aplikasi Android, atau berlangganan newsletter kami.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-5 flex items-center gap-3">
                <span className="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center text-sm">2</span>
                Informasi yang Kami Kumpulkan
              </h2>
              <div className="space-y-4 bg-gray-50 p-6 rounded-2xl">
                <p><strong>Informasi Pribadi:</strong> Nama, alamat email, nomor telepon (WhatsApp), dan informasi profil lainnya yang Anda berikan secara sukarela saat mendaftar program.</p>
                <p><strong>Data Penggunaan:</strong> Informasi teknis seperti alamat IP, jenis perangkat, dan versi sistem operasi untuk optimasi layanan aplikasi Android kami.</p>
                <p><strong>Izin Aplikasi:</strong> Aplikasi Android kami mungkin memerlukan akses notifikasi untuk mengirimkan update jadwal pelatihan secara real-time.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-5 flex items-center gap-3">
                <span className="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center text-sm">3</span>
                Keamanan Data
              </h2>
              <p>
                Kami mengimplementasikan standar keamanan tinggi termasuk enkripsi SSL dan firewall untuk melindungi data Anda. Kami tidak akan pernah menjual atau menyewakan informasi pribadi Anda kepada pihak ketiga manapun untuk tujuan komersial.
              </p>
            </section>

            <div className="bg-gradient-to-br from-indigo-600 to-purple-700 p-8 rounded-3xl text-white shadow-xl">
              <h2 className="text-2xl font-bold mb-4">Butuh Bantuan Hukum?</h2>
              <p className="opacity-90 mb-6 font-medium">
                Jika Anda memiliki pertanyaan mengenai penggunaan data Anda, tim perlindungan data kami siap membantu.
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-xl">info@candradimuka.id</div>
                <div className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-xl">0812-64656688</div>
              </div>
            </div>

            <p className="text-sm text-gray-400 pt-10 border-t border-gray-100 italic">
              Terakhir Diperbarui: 24 Mei 2024
            </p>
          </div>
        </motion.div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;